<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";
import {markRaw} from "vue";
import chartResizeMixin from "./chartResizeMixin";

export default {
    name: "secondDataLineEchart",
    mixins: [chartResizeMixin],
    props: {
        id: {
            type: String,
            default: "secondDataLineEchart"
        },
        title:{
            type: String,
            default:"折线图"
        },
        name:{
            type: String,
            default:""
        },
        dataList: {
            type: Array,
            default: []
        }
    },
    watch: {
        id(newValue, oldValue) {
            this.id = newValue;
        },
        dataList(newValue, oldValue) {
            this.chartList = newValue;
            this.init()
        }
    },
    data() {
        return {
            lineChart: null,
            chartList: [],
            maxNum: 40,
            chartOption: {
                title: {
                    text: '',
                    left: 'center'
                },
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    formatter: function (params) {
                        return '时间节点(分钟): ' + +params[0].value[0]  +
                          '<br>' + '百分比(比率): ' + params[0].value[1];
                    }
                },
                xAxis: {
                    name: '时间节点(分钟)',
                    type: 'value',
                    splitNumber: 10,
                    max: 100,
                    nameLocation:'center',
                    nameTextStyle: {
                        padding: [20, 0, 0, 0]
                    }
                },
                yAxis: {
                    name: '百分比(比率)',
                    type: 'value',
                    splitNumber: 10,
                    max: 100,
                },
                series: [
                    {
                        data: [],
                        type: 'line',
                        smooth: false,
                        symbolSize: 1,
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.chartList = this.dataList;
            if (!this.chartList || this.chartList.length === 0) {
                return
            }
            this.lineChart = markRaw(echarts.init(document.getElementById(this.id)));
            this.chartOption.series[0].data = this.chartList;
            this.chartOption.title.text = this.title
            this.lineChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    color: #333 !important;
    display: flex;

    > div {
        width: 100%;
        max-width: 460px;
        height: 380px;
        margin: auto;
    }

    div + div {
        margin-left: 10px;
    }
}
</style>